import TableDataCell from "./table-data-cell"
import TableDataRow from "./table-data-row"
import EditSelect from "./table-data-edit/eidt-select"
import EditBool from "./table-data-edit/edit-bool"
import EditLink from "./table-data-edit/eidt-link"
import EditInput from "./table-data-edit/edit-input"
import dayjs from "dayjs"

const TableData = ({
  className,
  datalist = [],
  columns = [],
  rowKey,
  selected = {},
  rowClick,
  onChange,
  onBlur,
  customRenders
}) => {
  return datalist.map((item) => (
    <TableDataRow
      key={item[rowKey]}
      className={className}
      isActive={selected[rowKey] === item[rowKey]}
      onClick={() => rowClick?.(item)}
    >
      {columns.map((column) => {
        const { key, editType, align } = column

        if (editType === "input") {
          return (
            <EditInput
              key={key}
              align={align}
              value={String(item[key] ?? "")}
              disabled={column.disabled?.(item)}
              onChange={(e) => onChange?.(item[rowKey], key, e.target.value)}
              onBlur={() => onBlur?.(item[rowKey], key)}
            />
          )
        }

        if (editType === "link") {
          return <EditLink key={key} to={column.to(item)} label={item[key]} />
        }

        if (editType === "bool") {
          return (
            <EditBool
              key={key}
              value={item[key]}
              onChange={(value) => onChange?.(item[rowKey], key, value)}
            />
          )
        }

        if (editType === "select") {
          return (
            <EditSelect
              key={key}
              options={column.options}
              value={item[key] ?? 0}
              onChange={(value) => onChange?.(item[rowKey], key, value)}
              disabled={column.disabled?.(item)}
            />
          )
        }

        if (editType === "custom") {
          return (
            <TableDataCell key={key} className={align ?? "text-center"}>
              {customRenders?.[key]?.(item)}
            </TableDataCell>
          )
        }

        return (
          <TableDataCell key={key} className={align ?? "text-center"}>
            {column.format ? dayjs(item[key]).format(column.format) : String(item[key] ?? "")}
          </TableDataCell>
        )
      })}
    </TableDataRow>
  ))
}

export default TableData
